// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pi.pi-spin[data-v-60a2fe69] {\n  opacity: 0.65;\n  font-size: 2.1rem !important;\n}\ndiv[data-v-60a2fe69] {\n  min-height: 40vh;\n}\n", ""]);
// Exports
module.exports = exports;
